import React, { Component } from 'react';
import { Container, Badge, Button, Alert } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { GoRepo } from "react-icons/go";
import Navigation from "context/nav";
import Utils from "context/utils";
import InfoTooltip from "components/controls/InfoTooltip";
import Clipboard from "blob_types/blobhub/compute/workflow/controls/common/clipboard";
import StatusIndicator from "components/controls/statusIndicator";
import UserIdentity from "components/controls/userIdentity";
import "./blobs.css";

export default class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {authors: {}};
  }

  componentDidMount() {
    this.loadAuthors();
  }

  componentDidUpdate(prevProps) {
    if ( prevProps.blobs !== this.props.blobs ) {
      this.loadAuthors();
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  // A row names its author and the listing carries only `user_id`. `usersIdGet` memoises by id, so a
  // list of blobs sharing an author costs one request.
  loadAuthors() {
    for ( const id of new Set((this.props.blobs || []).map(blob => blob.user_id).filter(Boolean)) ) {
      if ( this.state.authors[id] ) {
        continue;
      }
      this.props.app.api.usersIdGet(id).then(response => {
        if ( this.unmounted ) return;
        this.setState(state => ({authors: {...state.authors, [id]: response.data.user}}));
      }, () => {});
    }
  }

  render() {
    const orgId = this.props.orgId;
    const org = this.props.org;
    const blobs = this.props.blobs;
    return (
      <>
        <Container className="blob-header-row content-row blob-list-row">
          {this.props.app.api.canAdministerOrg(org) &&
            <>
              <div>
                &nbsp;
                <div className="float-right">
                  <span className="text-muted text-note">
                    Create a new blob to store data
                  </span>&nbsp;&nbsp;&nbsp;
                  <Button
                    variant="success"
                    size="sm"
                    href={Navigation.blobCreatePath(org)}><GoRepo/> New
                  </Button>
                </div>
              </div>
              <br/>
            </>
          }

          {blobs &&
            <>
              {blobs.map((blob, index) => {
                return (
                  <div key={blob.id}>
                    {/* Identity on the left, status mark at the far end. The alias gets no pill:
                        it is already the link when there is no name, and when there is a name it is
                        usually the same string — a pill would print it twice. Visibility is the one
                        pill here, so it keeps the glance it needs. */}
                    <h5 className="record-title">
                      <span className="record-title-main">
                        <Link to={"/" + orgId + "/" + blob.alias}>{Utils.displayName(blob)}</Link>
                        <Badge variant="secondary" className="title-tag-badge">{blob.visibility}</Badge>
                      </span>
                      <StatusIndicator status={blob.status}/>
                    </h5>
                    {blob.description &&
                      <div className="blob-item-row">
                        {blob.description}
                      </div>
                    }
                    {/* No labels. Two lines of monospace under a title are self-evidently the
                        record's identifiers, and "ID:" / "Type:" cost a column of width to say what
                        the tooltip says better on demand. Both values stay <code>: the design system
                        reserves monospace-pink for UUIDs, types, formats and paths — things you read
                        or copy — and gives the pill to names and states. */}
                    <div className="blob-item-row record-meta">
                      <span className="record-meta-value">
                        <code>{blob.id}</code>
                        <Clipboard text={blob.id}/>
                        <InfoTooltip placement="bottom" text="Blob id — what the API addresses this blob by."/>
                      </span>
                      <span className="record-meta-value">
                        <code>{blob.type}</code>
                        <Clipboard text={blob.type}/>
                        <InfoTooltip placement="bottom" text="Blob type — the component that stores and serves it."/>
                      </span>
                    </div>
                    {(blob.user_id || blob.created_at) &&
                      <div className="blob-item-row">
                        {blob.user_id &&
                          <UserIdentity user={this.state.authors[blob.user_id]} fallback={blob.user_id}
                            showIdentifier={false}/>
                        }
                        {blob.created_at && <>&nbsp;created {Utils.formatTimeAgo(blob.created_at)}</>}
                      </div>
                    }
                    {blob.tags && blob.tags.length > 0 &&
                      <div className="blob-item-row">
                        {blob.tags.map((tag, index) => {
                          return (
                            <>
                              <Badge variant="secondary" className="tag-badge">{tag}</Badge>
                              &nbsp;
                            </>
                          );
                        })}
                      </div>
                    }
                    <hr/>
                  </div>
                );
              })}
            </>
          }
          {!blobs &&
            <Alert variant="primary">Loading blobs...</Alert>
          }
        </Container>
      </>
    )
  }
}
